import { _request, APIBaseResponse,APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const AUTHORIZED_ISSUES_PATH_PREFIX = 'authorizedissuers';

type APIAuthorizedIssuerListParams = RequestParamsBase & {
    tenantId: string;
};

type APIAuthorizedIssuerListResponse = APIBaseResponse<
    Array<{
        tenantId: string;
        identityproviderId: string;
        identityProviderName: string;
        audience: string;
        isGlobal: boolean;
    }>
>;

type APIAuthorizedIssuerDeleteParams = {
    audience: string;
    authorizedIssuerId: string;
    tenantId: string;
};

export const APIAuthorizedIssuerGetList: APIMethod<APIAuthorizedIssuerListParams, APIAuthorizedIssuerListResponse> = (params: APIAuthorizedIssuerListParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${AUTHORIZED_ISSUES_PATH_PREFIX}`, undefined, params.signal)
);

type APIAuthorizedIssuerPostParams = {
    tenantId: string;
    identityProviderId: string;
    audience: string;
};

type APIAuthorizedIssuerPostResponse = APIBaseResponse;

export const APIAuthorizedIssuerPost: APIMethod<APIAuthorizedIssuerPostParams, APIAuthorizedIssuerPostResponse> = (params) => (
    _request<APIAuthorizedIssuerPostResponse>('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${AUTHORIZED_ISSUES_PATH_PREFIX}`, {
        tenantId: params.tenantId,
        identityProviderId: params.identityProviderId,
        audience: params.audience
    })
);

export const APIAuthorizedIssuerDelete: APIMethod<APIAuthorizedIssuerDeleteParams, APIBaseResponse> = (params) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${AUTHORIZED_ISSUES_PATH_PREFIX}/${params.authorizedIssuerId}/${params.audience}`)
);
